import Debug from '../helpers/debug.js';
import { baseApiBuilder } from '../helpers/baseBuilder.js';
import { env } from './env/index.js';

const debug = Debug('commands:env');

const command = 'env <action>';

const desc = 'Manage environment settings';

const builder = async function (yargs) {
  debug('builder', command);
  const base = await baseApiBuilder(yargs);
  return base.command(env);
};

const handler = async function (argv) {
  debug('handler', command, argv);
};

export { command, desc, builder, handler };
